var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "about-us") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875@20230817",
    transform: "translate(-1655.000000, -117.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-20",
    transform: "translate(0.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5173\\u4E8E\\u6211\\u4EEC",
    transform: "translate(1653.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5173\\u4E8E\\u6211\\u4EEC\\u56FE\\u6807",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25,21.75 C7.4512,21.75 2.75,17.0488 2.75,11.25 C2.75,5.4512 7.4512,0.75 13.25,0.75 C19.0488,0.75 23.75,5.4512 23.75,11.25 C23.75,17.0488 19.0488,21.75 13.25,21.75 Z M11.9578,10.55 L11.9578,15.7195 C11.9578,16.3736261 12.4880739,16.9039 13.1422,16.9039 C13.7963261,16.9039 14.3266,16.3736261 14.3266,15.7195 L14.3266,10.55 C14.3266,9.89587394 13.7963261,9.3656 13.1422,9.3656 C12.4880739,9.3656 11.9578,9.89587394 11.9578,10.55 Z M13.1338,5.5961 C12.8118,5.5961 12.5381,5.6955 12.312,5.9272 C12.0705,6.1428 11.9578,6.4242 11.9578,6.7728 C11.9578,7.1039 12.0705,7.3853 12.312,7.6177 C12.5381,7.8494 12.8118,7.96560146 13.1345,7.96560146 C13.4507166,7.9660808 13.7555539,7.84764404 13.9885,7.6338 C14.2139,7.4021 14.3266,7.1207 14.3266,6.7728 C14.3266,6.4249 14.2146,6.1428 13.9885,5.9272 C13.7631,5.6962 13.4726,5.5961 13.1345,5.5961 L13.1338,5.5961 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.8e46b9348d125446e826cb4f8a30144f.svg";
export { ForwardRef as ReactComponent };